import { render, staticRenderFns } from "./TabRequisitos.vue?vue&type=template&id=0e345758&scoped=true&"
import script from "./TabRequisitos.vue?vue&type=script&lang=js&"
export * from "./TabRequisitos.vue?vue&type=script&lang=js&"
import style0 from "./TabRequisitos.vue?vue&type=style&index=0&id=0e345758&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e345758",
  null
  
)

export default component.exports